// extracted by mini-css-extract-plugin
export default {"IntegrationPage":"styles_IntegrationPage__4N69g","iframe":"styles_iframe__XUcu+"};